"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.builtList = builtList;
exports.closed = closed;
exports.assignTask = assignTask;
exports.importTask = importTask;
exports.importList = importList;
exports.getNTotal = getNTotal;

var _request = _interopRequireDefault(require("@/utils/request"));

function builtList(query) {
  return (0, _request.default)({
    url: '/builtRecycle/list',
    method: 'get',
    params: query
  });
}

function closed(data) {
  return (0, _request.default)({
    url: '/builtRecycle/closed',
    method: 'post',
    data: data
  });
}

function assignTask(data) {
  return (0, _request.default)({
    url: '/builtRecycle/assignTask',
    method: 'post',
    data: data
  });
}

function importTask(data) {
  return (0, _request.default)({
    url: '/upload/uploadExcel',
    method: 'post',
    data: data
  });
}

function importList(query) {
  return (0, _request.default)({
    url: '/upload/list',
    method: 'get',
    params: query
  });
}

function getNTotal(query) {
  return (0, _request.default)({
    url: '/builtRecycle/getNTotal',
    method: 'get',
    params: query
  });
}